import { POST } from '../../../utils/httpMethods';

const getUrlTopinvest = async ({ idSimulation, idFoyerFiscal, beneficiary, ripId }) => {
    try {
        const response = await POST('/api/simulationsTopInvest/openSimulation', {
            body: { idSimulation, idFoyerFiscal, beneficiary, ripId },
        });
        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erreur lors de la récupération de l\'URL TopInvest:', error);
        throw error;
    }
};

export default getUrlTopinvest;
